import $ from 'jquery';

export default class ProjectService {
    static projects() {
        return $.ajax({
            url: '/rest/projects',
            type: 'get'
        });
    }

    static requestContact(contactMethod, contactDetails, projectTitle) {
        return $.ajax({
            url: '/rest/projects/request-contact',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify({
                contactMethod: contactMethod,
                contactDetails: contactDetails,
                projectTitle: projectTitle
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/members/project-service.js